<template>
  <span data-slot="lead-field-value">
    <template v-if="items.length === 0">–</template>
    <span v-for="(item, index) in items" :key="index">
      <template v-if="index !== 0">, </template>
      <span v-if="item.bool !== null" class="inline-flex items-center gap-1">
        <check-icon v-if="item.bool" class="size-4 text-success" aria-hidden="true" />
        <x-icon v-else class="size-4 text-muted-foreground" aria-hidden="true" />
        {{ item.bool ? tr('Yes') : tr('No') }}
      </span>
      <a
        v-else-if="item.link"
        :href="item.link"
        class="text-primary hover:underline"
        @click.stop
      >
        {{ item.value }}
      </a>
      <template v-else>{{ item.value }}</template>
    </span>
  </span>
</template>

<script>
import { Check, X } from '@lucide/vue';

/** The answer of a lead form field: links stay links, true/false become a check/cross with Yes/No. */
export default {
  name: 'LeadFieldValue',
  components: {
    CheckIcon: Check,
    XIcon: X,
  },
  props: {
    lead: {
      type: Object,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
  },
  computed: {
    items() {
      return this.lead.getFieldItems(this.field).map(item => ({
        ...item,
        bool: this.parseBool(item.value),
      }));
    },
  },
  methods: {
    parseBool(value) {
      const text = String(value ?? '').trim().toLowerCase();
      if (text === 'true') {
        return true;
      }
      if (text === 'false') {
        return false;
      }

      return null;
    },
  },
};
</script>
